<div class="container">
    <div class="row">
        <div class="col-md-12">
            <div class="trending-items">
                <div class="title-box">
                    <h2 class="text-primary">Customers Frequently Viewed</h2>
                </div>
                <div class="recommendations-container">
                    <swiper-container appSwiper [shouldLoop]="true" [slideData]="recommendations" #swiper class="recommendations-carousel">
                        <swiper-slide *ngFor="let recommendation of recommendations">
                            <app-product-card
                                [product]="recommendation" 
                                class="recommendations-swiper-product"
                                [source]="source"
                                (addedToCart)="addedToCart.emit($event)"
                            ></app-product-card>
                        </swiper-slide>
                    </swiper-container>
                </div>
            </div>
        </div>
    </div>
</div>